import React from 'react'
import './spinner.css'

const Spinner = () => (

  <div className="loader" />

)
export default Spinner
